// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate,useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientTreatmentForm from "../Forms/PatientTreatmentForm";
import CONFIG from '../../config';
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";

// EditStudent Component 
const EditPatientTreatment = () => {
  const { markSectionComplete } = useOutletContext() ;  
        const navigate = useNavigate();
        const { verifyTokenAndRedirect } = useAuth();
        const {patientData, setPatientData, selectedCase, selectedVisit, doctorInfo} = usePatient();
        const {patientId, caseId, visitId} = useParams();        
        const location = useLocation();

     
  useEffect(()=>{

    verifyTokenAndRedirect();

  }, []);



  //onSubmit handler 
  const onSubmitHandler = (updatedPatientTreatment) => {

    console.log('patient data after symptoms updation',updatedPatientTreatment);


// const updatedData = {
//   ...patientData, 
//   patientTreatment: [{ ...updatedPatientTreatment }] // Overwrite patientInfo while keeping other data unchanged
// };

// const updatedData = {
//   ...patientData, 
//   patientTreatment: patientData.patientTreatment.map(info => ({
//       ...info, // Keep existing patientInfo fields
//       ...updatedPatientTreatment // Merge updated fields
//   }))
// };

// const updatedData = {
//   ...patientData,
//   patientTreatment: patientData.patientTreatment.length > 0 
//       ? patientData.patientTreatment.map(info => ({
//           ...info, // Keep existing patientInfo fields
//           ...updatedPatientTreatment // Merge updated fields
//       }))
//       : [updatedPatientTreatment] // If empty, create a new array with updatedPatientTreatment
// };

const updatedData = {
  ...patientData,
  patientTreatment: patientData?.patientTreatment?.length > 0 
      ? patientData.patientTreatment.map(info => ({
          ...info, // Keep existing patientInfo fields
          ...updatedPatientTreatment, // Merge updated fields
          PATIENT_ID: patientData.PATIENT_ID, 
          CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
          VISIT_ID: selectedVisit || visitId,  // Add VISIT_ID if missing
          DOCTOR_ID: doctorInfo.MANDALI_ID,
          CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
  
      }))
      : [{
          ...updatedPatientTreatment,
          PATIENT_ID: patientData.PATIENT_ID, 
          CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
         VISIT_ID: selectedVisit || visitId, // Default VISIT_ID if not provided
         DOCTOR_ID: doctorInfo.MANDALI_ID,
         CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
 
      }]
};
  

setPatientData(updatedData);
markSectionComplete("treatment");
if (location.pathname.startsWith("/addpatient")) {
  navigate("/addpatient/payment");
} else if (location.pathname.startsWith("/visits")) {
  navigate(`/visits/${patientId}/${caseId}/${visitId}/payment`);
} else {
  console.warn("Unknown route, no redirection");
}

  };


  // Return student form 
  return (

    <div>
      {console.log('inside rendering: ', patientData)}
      {patientData && (
        <PatientTreatmentForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientTreatmentForm>
      )}
    </div>
  );

};

export default EditPatientTreatment;

